import { render, staticRenderFns } from "./parking-list-table.vue?vue&type=template&id=ec70da64"
import script from "./parking-list-table.vue?vue&type=script&lang=js"
export * from "./parking-list-table.vue?vue&type=script&lang=js"
import style0 from "./parking-list-table.vue?vue&type=style&index=0&id=ec70da64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports